import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recurrent',
  templateUrl: './recurrent.component.html',
  styleUrls: ['./recurrent.component.css']
})
export class RecurrentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
